import classNames from 'classnames'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { PromoPageKeys } from 'sections/PromoSection/pages/PromoPage/types'
import { TextPromo } from 'components/ui'
import { useResize } from 'utils/hooks/useResize'

import s from './Step.module.scss'

interface StepProps {
  desktopImage: string
  mobileImage: string
  tabletImage: string
  title: string
  caption: string
  customClass?: string
}

export const Step: FC<StepProps> = ({ desktopImage, mobileImage, tabletImage, title, caption, customClass }) => {
  const { isDesktop, isMobile } = useResize()
  const { t } = useTranslation()

  const imageSrc = isDesktop ? desktopImage : isMobile ? mobileImage : tabletImage

  const getKey = (key: string) => `${PromoPageKeys.openingSteps}.${key}`

  return (
    <div className={classNames(s.step, customClass)} style={{ backgroundImage: `url(${imageSrc})` }}>
      <TextPromo size="s20" className={s.text}>
        {t(getKey(title))}
      </TextPromo>
      {caption && (
        <TextPromo size="s16" fontFamily="ASLHauss" className={s.textCaption} center={isMobile}>
          {t(getKey(caption), { br: isDesktop ? '\n' : '' })}
        </TextPromo>
      )}
    </div>
  )
}
